"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Mailto;
const jsx_runtime_1 = require("react/jsx-runtime");
function Mailto(props) {
    const { className, email, subject, body, children } = props, others = __rest(props, ["className", "email", "subject", "body", "children"]);
    const classes = `underline ${className ? className : ""}`;
    const params = subject || body ? `?subject=${encodeURIComponent(subject || "")}&body=${encodeURIComponent(body || "")}` : "";
    return ((0, jsx_runtime_1.jsx)("a", { className: classes, href: `mailto:${email}${params}`, children: children }));
}
